<template>
  <div class="debug-container">
    <h2>调试信息</h2>

    <el-card class="debug-card">
      <div slot="header">
        <span>Store 状态</span>
      </div>
      <pre>{{ storeState }}</pre>
    </el-card>

    <el-card class="debug-card">
      <div slot="header">
        <span>路由信息</span>
      </div>
      <pre>{{ routeInfo }}</pre>
    </el-card>

    <el-card class="debug-card">
      <div slot="header">
        <span>权限信息</span>
      </div>
      <pre>{{ permissionInfo }}</pre>
    </el-card>

    <el-card class="debug-card">
      <div slot="header">
        <span>可用路由</span>
      </div>
      <pre>{{ availableRoutes }}</pre>
    </el-card>

    <el-card class="debug-card">
      <div slot="header">
        <span>Token 测试</span>
      </div>
      <div class="token-test">
        <el-button type="primary" @click="testTokenRefresh"
          >测试Token刷新</el-button
        >
        <el-button type="warning" @click="simulateTokenExpiry"
          >模拟Token过期</el-button
        >
        <el-button type="danger" @click="clearTokens">清除所有Token</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Debug",
  computed: {
    ...mapGetters(["token", "adminInfo", "permissions", "addRouters"]),
    storeState() {
      return {
        token: this.token,
        adminInfo: this.adminInfo,
        permissions: this.permissions,
        addRouters: this.addRouters,
      };
    },
    routeInfo() {
      return {
        currentRoute: this.$route.path,
        allRoutes: this.$router.options.routes,
        addRouters: this.addRouters,
      };
    },
    permissionInfo() {
      return {
        permissions: this.permissions,
        hasSystemManage: this.permissions.includes("SYSTEM_MANAGE"),
        hasUserManage: this.permissions.includes("USER_MANAGE"),
        hasGroupManage: this.permissions.includes("GROUP_MANAGE"),
      };
    },
    availableRoutes() {
      const allRoutes = this.$router.options.routes.concat(
        this.addRouters || []
      );
      return allRoutes.filter((route) => route.meta && route.meta.title);
    },
  },
  methods: {
    async testTokenRefresh() {
      try {
        await this.$store.dispatch("admin/refreshToken");
        this.$message.success("Token刷新成功");
      } catch (error) {
        this.$message.error("Token刷新失败: " + error.message);
      }
    },
    simulateTokenExpiry() {
      // 模拟token过期，设置一个无效的token
      this.$store.commit("admin/SET_TOKEN", "invalid_token");
      this.$message.warning("已设置无效token，请尝试访问需要权限的页面");
    },
    clearTokens() {
      this.$store.dispatch("admin/logout");
      this.$message.info("已清除所有token");
    },
  },
  mounted() {
    console.log("Debug mounted");
    console.log("Store state:", this.storeState);
    console.log("Route info:", this.routeInfo);
    console.log("Permission info:", this.permissionInfo);
  },
};
</script>

<style scoped>
.debug-container {
  padding: 20px;
}

.debug-card {
  margin-bottom: 20px;
}

pre {
  background: #f5f5f5;
  padding: 10px;
  border-radius: 4px;
  overflow-x: auto;
  white-space: pre-wrap;
  word-wrap: break-word;
}

.token-test {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}
</style>
